import { DEFAULT_CSS_PREFIX_KEY } from "../core";
import { createInstance } from "./createInstance";
export { extractStaticStyle } from "./extractStaticStyle";
export { setupStyled } from "./setupStyled";
export { createInstance };
var styleInstance = createInstance({
  key: DEFAULT_CSS_PREFIX_KEY,
  speedy: false
});
var createStyles = styleInstance.createStyles,
  createGlobalStyle = styleInstance.createGlobalStyle,
  createStylish = styleInstance.createStylish,
  css = styleInstance.css,
  cx = styleInstance.cx,
  keyframes = styleInstance.keyframes,
  injectGlobal = styleInstance.injectGlobal,
  styleManager = styleInstance.styleManager,
  ThemeProvider = styleInstance.ThemeProvider,
  StyleProvider = styleInstance.StyleProvider,
  useTheme = styleInstance.useTheme;
export { createStyles, createGlobalStyle, createStylish, css, cx, keyframes, injectGlobal, styleManager, ThemeProvider, StyleProvider, useTheme };